<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :staticFilters="staticFilters"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :setImport="true"
    />
  </card>
</template>
<script>
export default {
  name: "customers",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      staticFilters: [
        {
          title: "Код:",
          key: "code",
          default: null,
          items: [
            {
              id: null,
              title: "Все",
            },
            {
              id: "200",
              title: "200",
            },
            {
              id: "201",
              title: "201",
            },
            {
              id: "302",
              title: "302",
            },
            {
              id: "422",
              title: "422",
            },
            {
              id: "500",
              title: "500",
            },
          ],
        },
        {
          title: "Метод:",
          key: "method",
          default: null,
          items: [
            {
              id: null,
              title: "Все",
            },
            {
              id: "PUT",
              title: "PUT",
            },
            {
              id: "POST",
              title: "POST",
            },
            {
              id: "DELETE",
              title: "DELETE",
            },
          ],
        },
      ],
      modalCreate: "customer",
      fields: [
        {
          col: "col-12 col-md-6",
          key: "phone",
          label: "Номер телефона",
          type: "mask",
          mask: "+998#########",
          placeholder: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_log",
      itemLink: "logs",
      setLink: "logs",
      columns: [
        {
          key: "id",
          title: "Номер",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "code",
          title: "Код ответа",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "method",
          title: "Метод",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          title: "Пользователь",
          object: "phone",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "route",
          title: "Ссылка",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "ip_address",
          title: "IP-адрес",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "created_at",
          title: "Дата",
          checkbox: false,
          dateTimeFormat: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "user_agent",
          title: "Платформа",
          object: "user-agent",

          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
